/* eslint import/no-unresolved: 0 */
import {
  ArrowExitRegular,
  ArrowDownRegular,
  ArrowUpRegular,
  ArrowLeftRegular,
  ArrowRightRegular,
  EditRegular,
  DeleteRegular,
  CheckmarkRegular,
  DismissRegular,
  ZoomInRegular,
  ZoomOutRegular,
  AddRegular,
  SubtractRegular,
  LocationRegular,
  ErrorCircleRegular,
  ArrowUploadRegular,
  EyeRegular,
  HeartRegular,
  ArrowSortUpRegular,
  QuestionCircleRegular,
  WifiOffRegular,
  type FluentIconsProps
} from '@fluentui/react-icons'

// Icon wrapper components using Fluent icons
export const ExitIcon = (props: FluentIconsProps) => <ArrowExitRegular {...props} />
export const ArrowDownIcon = (props: FluentIconsProps) => <ArrowDownRegular {...props} />
export const ArrowUpIcon = (props: FluentIconsProps) => <ArrowUpRegular {...props} />
export const ArrowLeftIcon = (props: FluentIconsProps) => <ArrowLeftRegular {...props} />
export const ArrowRightIcon = (props: FluentIconsProps) => <ArrowRightRegular {...props} />
export const EditIcon = (props: FluentIconsProps) => <EditRegular {...props} />
export const DeleteIcon = (props: FluentIconsProps) => <DeleteRegular {...props} />
export const CheckmarkIcon = (props: FluentIconsProps) => <CheckmarkRegular {...props} />
export const CloseIcon = (props: FluentIconsProps) => <DismissRegular {...props} />
export const ZoomInIcon = (props: FluentIconsProps) => <ZoomInRegular {...props} />
export const ZoomOutIcon = (props: FluentIconsProps) => <ZoomOutRegular {...props} />
export const PlusIcon = (props: FluentIconsProps) => <AddRegular {...props} />
export const MinusIcon = (props: FluentIconsProps) => <SubtractRegular {...props} />
export const LocationIcon = (props: FluentIconsProps) => <LocationRegular {...props} />
export const AlertIcon = (props: FluentIconsProps) => <ErrorCircleRegular {...props} />
export const UploadIcon = (props: FluentIconsProps) => <ArrowUploadRegular {...props} />
export const ViewIcon = (props: FluentIconsProps) => <EyeRegular {...props} />
export const HeartIcon = (props: FluentIconsProps) => <HeartRegular {...props} />
export const AscendingIcon = (props: FluentIconsProps) => <ArrowSortUpRegular {...props} />
export const QuestionMarkIcon = (props: FluentIconsProps) => <QuestionCircleRegular {...props} />
export const ConnectionDownIcon = (props: FluentIconsProps) => <WifiOffRegular {...props} />
